<div ngbDropdown container="body" [placement]="placement" class="float-end">
   <button type="button" class="btn btn-sm btn-light" id="price-history" ngbDropdownToggle
      (click)="toggle();$event.stopPropagation();">
      <i class="fa fa-history"></i> {{'financial.price'|translate}}{{'entity.history'|translate|lowercase}}
   </button>
   <div ngbDropdownMenu [attr.aria-labelledby]="'price-history'" class="table-cell price-history">
      <article-price-history-table [data]="data" [price_id]="price_id"></article-price-history-table>
   </div>
</div>
